import * as types from './constants';

export function setMapBounds(bounds) {
  return { type: types.SET_MAP_BOUNDS, data: bounds };
}
